import dayjs from "dayjs"
import { convertTimestampToDay } from "./convertTimestampToDay"

export function generateWeekDays(formData, userTimezone) {
  const allWeekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  const today = dayjs().tz(userTimezone)
  const currentDay = today.day()
  const dayOffset = (currentDay + 6) % 7
  const mondayStart = today.subtract(dayOffset, 'day').startOf('day')

  const days = Array.from({ length: 7 }, (_, i) => {
    const dayDate = mondayStart.add(i, 'day').tz(userTimezone)
    const timestamp = dayDate.valueOf()

    return {
      key: timestamp.toString(),
      label: dayDate.format('dddd'),
      timestamp,
    }
  })

  days.sort((a, b) => allWeekdays.indexOf(a.label) - allWeekdays.indexOf(b.label))

  const updatedFormData = {}
  days.forEach(({ key }) => {
    const existingDayData = formData[key]
    updatedFormData[key] = {
      start: existingDayData ? existingDayData.start : '',
      end: existingDayData ? existingDayData.end : '',
      checked: existingDayData ? existingDayData.checked : false,
      dayString: convertTimestampToDay(key, userTimezone),
    }
  })
  return updatedFormData
}